import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import moment from 'moment';

/** Rows render dates as DD/MM/YY, so the month filter reads them back in the same format. */
const ROW_DATE_FORMAT = 'DD/MM/YY';
const MONTH_FORMAT = 'YYYY-MM';

/** Workflow stages a bill can sit in, in pipeline order rather than alphabetical. */
export const BILL_STATUS_OPTIONS = ['Pending', 'Extracted', 'Validated', 'Failed'];
const UTILITY_LABEL_BY_ICON = {
  electricity: 'Electricity',
  irrigation: 'Irrigation',
  meter: 'Other',
  'natural-gas': 'Gas',
  property: 'Property',
  sewer: 'Sewer',
  solar: 'Solar',
  steam: 'Steam',
  trash: 'Trash',
  water: 'Water',
  'water/sewer': 'Water/Sewer'
};

/**
 * The utilities column is icon-only, so the filter labels are derived from those icons. Going
 * through the icon keeps demo rows and uploaded rows on the same vocabulary.
 */
export function getUtilityLabel(iconType) {
  return UTILITY_LABEL_BY_ICON[iconType] || 'Other';
}
export const EMPTY_BILL_FILTERS = {
  properties: [],
  providers: [],
  servicePeriod: '',
  statuses: [],
  utilities: []
};
export function hasActiveBillFilters(filters) {
  return Boolean(filters.properties.length || filters.providers.length || filters.statuses.length || filters.utilities.length || filters.servicePeriod);
}
const unique = values => [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b));

/** Options come from the rows themselves, so the lists never offer a value that matches nothing. */
export function getBillFilterOptions(rows) {
  return {
    properties: unique(rows.flatMap(row => row.propertiesLines || [])),
    providers: unique(rows.map(row => row.provider)),
    utilities: unique(rows.flatMap(row => row.utilityTypes || []))
  };
}
function coversMonth(servicePeriod, month) {
  const _String$split = String(servicePeriod || '').split(' - '),
    _String$split2 = _slicedToArray(_String$split, 2),
    startText = _String$split2[0],
    endText = _String$split2[1];
  const start = moment(startText, ROW_DATE_FORMAT, true);
  const end = moment(endText, ROW_DATE_FORMAT, true);
  const selected = moment(month, MONTH_FORMAT, true);
  if (!start.isValid() || !end.isValid() || !selected.isValid()) return false;
  return selected.isSameOrAfter(start, 'month') && selected.isSameOrBefore(end, 'month');
}

/** A row has to satisfy every filled-in filter; multiple values within one filter are an OR. */
export function matchesBillFilters(row, filters) {
  if (filters.statuses.length && !filters.statuses.includes(row.status)) return false;
  if (filters.providers.length && !filters.providers.includes(row.provider)) return false;
  if (filters.properties.length && !(row.propertiesLines || []).some(line => filters.properties.includes(line))) {
    return false;
  }
  if (filters.utilities.length && !(row.utilityTypes || []).some(utility => filters.utilities.includes(utility))) {
    return false;
  }
  return !filters.servicePeriod || coversMonth(row.servicePeriod, filters.servicePeriod);
}